import React from "react";
import { Link } from "react-router-dom";

// Icons
import EyeIcon from "../../../asset/images/home/icon/fi-rr-eye.png";

// Student Images
import Student1 from "../../../asset/images/home/modules/1.png";
import Student2 from "../../../asset/images/home/modules/2.png";
import Student3 from "../../../asset/images/home/modules/3.png";
import Student4 from "../../../asset/images/home/modules/4.png";
import Student5 from "../../../asset/images/home/modules/5.png";

const SyllableSee = () => {
    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 13: Decoding Multi-Syllabic words
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Virtual Class Demo
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        that you’ve learned how to teach students to learn the sounds of the alphabet,
                        let’s take this further by demonstrating with A.I. students. These are compliant
                        students that will repeat whatever you say. There is an expectation for a correct
                        response from you.
                    </p>
                </div>

                {/* See Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-32 flex items-center justify-center">
                        <img src={EyeIcon} height="20" width="20" className="mr-2" alt="" />
                        See
                    </button>
                </div>

                {/* Student Images */}
                <div className="flex justify-center gap-2 flex-wrap bg-[#E2F2FF] py-6 rounded-xl mb-8">
                    <img src={Student1} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student2} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student3} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student4} alt="Student" className="w-50 h-50 object-cover" />
                    <img src={Student5} alt="Student" className="w-50 h-50 object-cover" />
                </div>

                {/* Card Section */}
                <div className="max-w-7xl w-full">
                    <div className="bg-white rounded-xl shadow-lg p-8 md:p-16 text-center">

                        <h1 className="text-3xl md:text-4xl text-gray-800 mb-8">
                            Extravagant
                        </h1>

                        <div className="flex flex-wrap justify-center gap-2 md:gap-8">
                            {["E","X","T","R","A","V","A","G","A","N","T"].map((letter, index) => (
                                <button
                                    key={index}
                                    className="letter-btn border border-primary w-12 h-12 md:w-14 md:h-14 hover:bg-gray-300 hover:border text-black font-semibold rounded-lg transition-all duration-200 hover:-translate-y-1 flex items-center justify-center text-lg md:text-xl"
                                >
                                    {letter}
                                </button>
                            ))}
                        </div>

                    </div>
                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-center mt-5">
                    <Link to="/dashboard/modules/syllable-hear">
                        <button className="px-8 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Next →
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
};

export default SyllableSee;
